import { createContext } from 'react';

export interface AdAuthContextProps {
  logout: () => void;
  handleCiamLogin: () => void;
}

export const ContentContext = createContext({});
export const LabelContentContext = createContext({});
export const AdAuthContext = createContext<AdAuthContextProps>(null);
